import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { HistCusDto } from './RatingPrice';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
export class PriceOtherControl {
    isCusValue : boolean = false;
    isWarningTreatment : boolean = false;
    isMSGcheckLab1st : boolean = false;
    isMSGcheckLab2nd : boolean = false;
    isMSGcheckLab3rd : boolean = false;
    ishouseCare  : boolean = false;
    isEditSupArea: boolean = false;
    histCusDto :HistCusDto;
    rxCheckWholehist: WholeHist;
}


export class RatingPrice共同藥品UISet {
    hasPharmacist:boolean = false;
    hasDrug:boolean = false;
    hasNeedleDrug:boolean = false;
    has二類三類:boolean = false;
    selectedPharm:number = 0;
    hasExam:boolean = false;
    hasInjectionSelfDisp :boolean = false;
    dxSelectDept:string = '';
    needDxDept:boolean = false;
}


export class RatingPrice特殊轉代UISet {
    IsTM:boolean = false;
    TMDoctor:string= '';
    TMRefHosp:string= '';
    TMHospOpt: ValueTextPair[]=[];
    TMDoctorOpt: ValueTextPair[]=[];
    IsP81:boolean = false;

    isTMOrder(order: { RxCode?: string; StdCode?: string }): boolean {
        return order?.RxCode == 'TMR01' || order?.RxCode == 'TMP01';
    }

    isP81Order(order: { RxCode?: string; StdCode?: string }): boolean {
        return order?.StdCode == 'P8107C' || order?.StdCode == 'P8108C';
    }

    isHospitalTransferOrder(order: { RxCode?: string; StdCode?: string }): boolean {
        return this.isTMOrder(order) || this.isP81Order(order);
    }

    setSpecialTransferFlags(hrxs: Array<{ RxCode?: string; StdCode?: string }>): void {
        const orders = hrxs || [];
        this.IsP81 = orders.some(x => this.isP81Order(x));
        this.IsTM = orders.some(x => this.isTMOrder(x));
    }
}

